import styled from 'styled-components';
import { playFocus } from 'app/ui-components/utils.styles';
import { iconExternal } from '../../../../ui-components/design-tokens';
import { playFontIcon } from '../../../../ui-components/typography/helpers';
import { PlayTextStyles } from '../../../../ui-components/typography/PlayText/PlayText.styles';
import PlayText from '../../../../ui-components/typography/PlayText/PlayText';

type StyledEditorialMessageProps = {
    urgent: boolean;
};

export const StyledEditorialMessage = styled.div<StyledEditorialMessageProps>`
    margin-top: ${(props) => (props.urgent ? 0 : '1.5em')};
    margin-bottom: ${(props) => (props.urgent ? '1.5em' : 0)};
`;

export const StyledEditorialMessageText = styled(PlayText)`
    line-height: 1.6;
`;

export const StyledEditorialMessageLink = styled.a`
    ${PlayTextStyles};
    ${playFocus()}

    &:before {
        ${playFontIcon(1.3, iconExternal)}
        font-size: 1.2em;
        margin-right: 7px;
        text-decoration: none;
    }

    span {
        text-decoration: underline;
        text-underline-position: under;
    }
`;
